<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre3">[Personen]</h3>
<table cellpadding="5" cellspacing="0" class="center1" width="60%">
<tbody><tr class="calibre4">
<td class="calibre5">
<h4 class="calibre6 sigil_not_in_toc">Personen des Vorspiels:</h4>
<dl class="calibre7">
<dt class="calibre8">Peter Saburoff,</dt>
<dd class="calibre9">Schankwirt.</dd>
<dt class="calibre8">Vera Saburoff,</dt>
<dd class="calibre9">seine Tochter.</dd>
<dt class="calibre8">Michael, .</dt>
<dd class="calibre9">ein Bauer</dd>
<dt class="calibre8">Oberst Kotemkin.</dt>
</dl>
<p class="leftmarg">Ort der Handlung: Rußland. Zeit: 1795.</p>
<h4 class="calibre6 sigil_not_in_toc">Personen des Stückes:</h4>
<dl class="calibre7">
<dt class="calibre8">Zar Iwan.</dt>
<dt class="calibre8">Fürst Paul Maraloffski,</dt>
<dd class="calibre9">Premierminister in Rußland.</dd>
<dt class="calibre8">Fürst Petrowitsch.</dt>
<dt class="calibre8">Graf Ruvaloff.</dt>
<dt class="calibre8">Baron Raff.</dt>
<dt class="calibre8">Marquis de Poivrard.</dt>
<dt class="calibre8">General Kotemkin</dt>
<dt class="calibre8">Ein Page.</dt>
<dt class="calibre8">Nihilisten:</dt>
<dt class="calibre8">Peter Tschernawitsch,</dt>
<dd class="calibre9">Präsident der Nihilistenvereinigung.</dd>
<dt class="calibre8">Michael.</dt>
<dt class="calibre8">Alexis Iwantschiewitsch,</dt>
<dd class="calibre9">angeblich Student der Medizin.</dd>
<dt class="calibre8">Professor Marfa.</dt>
<dt class="calibre8">Vera Saburoff.</dt>
<dt class="calibre8">Soldaten, Verschwörer usw.</dt>
</dl>
<p class="leftmarg">Ort der Handlung: Moskau. Zeit: 1800. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page4" title="auguste64/DaoH"></a> <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page5" title="divisi/KaFa"></a></p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?2af49650